export default "__VITE_ASSET__Cdp1eMTk__"